import {
  SignupAction,
  SignupActionType,
  SignupSession,
  SignupState,
  Subscription
} from '../types'
import { AsyncDispatch } from '../hooks/useAsyncReducer'
import {
  createPartialSubscription,
  fetchPartialSubscription,
  createSubscription,
  convertFlipSubscription,
  replacePrinter
} from '../stateData/actions'

let conversionInProgress = false

export const startSignupSession = ({
  partialSubscriptionId,
  printerUuid,
  printerBizModel,
  printerSku,
  printerSerialNumber,
  flowType,
  initiator,
  accountIdentifier,
  printerIdParam,
  planTypeSelectorInitialStep
}: Partial<SignupSession> & { flowType?: string }) => async (
  dispatch: AsyncDispatch<SignupAction, SignupState>
) => {
  await dispatch({
    type: SignupActionType.START_SIGNUP_SESSION
  })

  const partialSubscription = await dispatch(
    partialSubscriptionId
      ? fetchPartialSubscription(partialSubscriptionId)
      : createPartialSubscription(
          printerUuid,
          printerBizModel,
          printerSku,
          printerSerialNumber,
          flowType,
          accountIdentifier
        )
  )

  await dispatch(
    updateSignupSession({
      partialSubscriptionId: partialSubscription['id'],
      partialSubscriptionFlowName: partialSubscription['flowName'],
      requireBilling: partialSubscription['requireBilling'],
      ...(initiator ? { initiator } : {}),
      ...(printerIdParam ? { printerIdParam } : {}),
      ...(accountIdentifier ? { accountIdentifier } : {}),
      ...(planTypeSelectorInitialStep ? { planTypeSelectorInitialStep } : {})
    })
  )

  return partialSubscription
}

export const updateSignupSession = (
  newValues: Record<string, unknown>
) => async (dispatch: AsyncDispatch<SignupAction, SignupState>) => {
  await dispatch({
    type: SignupActionType.UPDATE_SIGNUP_SESSION,
    signupSession: newValues
  })
}

export const completeEnrollmentSignupSession = () => async (
  dispatch: AsyncDispatch<SignupAction, SignupState>
) => {
  const { accountIdentifier } = (await dispatch(
    createSubscription()
  )) as Subscription

  await dispatch(updateSignupSession({ accountIdentifier }))
}

export const completeConversionSignupSession = () => async (
  dispatch: AsyncDispatch<SignupAction, SignupState>
) => {
  if (conversionInProgress) {
    return
  }

  conversionInProgress = true

  try {
    await dispatch(convertFlipSubscription())
    await dispatch(updateSignupSession({ flipConverted: true }))
  } finally {
    conversionInProgress = false
  }
}

export const completeReplacementSignupSession = () => async (
  dispatch: AsyncDispatch<SignupAction, SignupState>
) => {
  const { accountIdentifier } = (await dispatch(
    replacePrinter()
  )) as Subscription

  await dispatch(
    updateSignupSession({
      printerReplaced: true,
      accountIdentifier
    })
  )
}

export const exitSignupSession = () => async (
  dispatch: AsyncDispatch<SignupAction, SignupState>
) =>
  dispatch(
    updateSignupSession({
      accountIdentifier: undefined,
      partialSubscriptionId: undefined,
      partialSubscriptionFlowName: undefined,
      requireBilling: undefined,
      initiator: undefined,
      currentStep: undefined,
      printerUuid: undefined,
      printerBizModel: undefined,
      printerSerialNumber: undefined,
      printerSku: undefined,
      printerDisplayName: undefined,
      printerImageUrl: undefined,
      showShippingModal: undefined,
      showMissingPhoneModal: undefined,
      forcePlanModal: undefined,
      savedPlanGUIDIsRecommendation: undefined,
      flipConverted: undefined,
      appInstanceID: undefined,
      planTypeSelectorInitialStep: undefined,
      shippingAddedOnShippingStep: undefined,
      savedEditPlanGUID: undefined
    })
  )
